// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IProcessorInfo
 */
export interface IProcessorInfo {
    /**
     * System where the Processing took Place.
     * @type {string}
     * @memberof IProcessorInfo
     */
    system?: string | null;
    /**
     * Cycle where the Processing took Place.
     * @type {string}
     * @memberof IProcessorInfo
     */
    cycle?: string | null;
    /**
     * Terminal Owning Region in CICS where the transaction was initially received.
     * @type {string}
     * @memberof IProcessorInfo
     */
    tor?: string | null;
    /**
     * Capabilities of the processing environment. READ/WRITE or  READ ONLY.
     * @type {string}
     * @memberof IProcessorInfo
     */
    mode?: string | null;
}

/**
 * Check if a given object implements the IProcessorInfo interface.
 */
export function instanceOfIProcessorInfo(value: object): value is IProcessorInfo {
    return true;
}

export function IProcessorInfoFromJSON(json: any): IProcessorInfo {
    return IProcessorInfoFromJSONTyped(json, false);
}

export function IProcessorInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessorInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'system': json['system'] == null ? undefined : json['system'],
        'cycle': json['cycle'] == null ? undefined : json['cycle'],
        'tor': json['tor'] == null ? undefined : json['tor'],
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}

export function IProcessorInfoToJSON(json: any): IProcessorInfo {
    return IProcessorInfoToJSONTyped(json, false);
}

export function IProcessorInfoToJSONTyped(value?: IProcessorInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'system': value['system'],
        'cycle': value['cycle'],
        'tor': value['tor'],
        'mode': value['mode'],
    };
}

